/**
 * Clés du domaine `auth` — les appels NON authentifiés du parcours d'entrée
 * (inscription, mot de passe oublié) et la validation d'e-mail. Rien n'est mis
 * en cache : seules les mutations sont préfixées.
 */
export const authKeys = {
  all: ['auth'] as const,

  mutations: () => [...authKeys.all, 'mutation'] as const,
} as const;
